/**
 * LOBBERO STAYS — a same-day turnaround's cleaning window (ai-plans/stays plan
 * S8, R-S8.17). The twin of windowFacts() in
 * lobbero_be/src/stays/operations/turnaround.js over the same cases
 * (stays-turnaround.cases.json, a COPY kept by check-fe-copy.js). The server
 * answers each pair already worked out; this twin words a window the screen
 * holds (and proves the words match the server's).
 *
 * An arrival before the checkout is 0 minutes and `overlap` — never Konios's
 * "+24 hours" wrap, which made the most urgent turnaround look the calmest.
 */

export const URGENT_MINUTES = 120;

export interface TurnaroundFacts {
  window_minutes: number;
  overlap: boolean;
  urgent: boolean;
  hours_label: string;
}

export const hoursLabel = (minutes: number, overlap: boolean): string => {
  if (overlap) return 'Arrival is before checkout';
  if (minutes <= 0) return '0 hours (immediate turnaround)';
  const h = Math.round(minutes / 6) / 10;
  const txt = Number.isInteger(h) ? String(h) : h.toFixed(1);

  return `${txt} ${h === 1 ? 'hour' : 'hours'}`;
};

export const windowFacts = (outAt: string | Date, inAt: string | Date): TurnaroundFacts => {
  const ms = (v: string | Date) => (v instanceof Date ? v.getTime() : Date.parse(v));
  const diff = Math.round((ms(inAt) - ms(outAt)) / 60000);
  const overlap = diff < 0;
  const minutes = overlap ? 0 : diff;

  return { window_minutes: minutes, overlap, urgent: minutes <= URGENT_MINUTES, hours_label: hoursLabel(minutes, overlap) };
};

/** The pill's words: "4 hours to clean", or the two special cases as they are. */
export const windowPillLabel = (f: Pick<TurnaroundFacts, 'window_minutes' | 'overlap' | 'hours_label'>): string =>
  f.overlap || f.window_minutes <= 0 ? f.hours_label : `${f.hours_label} to clean`;
